// idefix Satıcı uygulaması indirme linkleri ve platform yönlendirme yardımcıları.
// Hem giriş ekranındaki QR/butonlar hem de /app yönlendirme sayfası bu değerleri kullanır.

export const APP_IOS_URL = 'https://apps.apple.com/cy/app/idefix-sat%C4%B1c%C4%B1-paneli/id6763008590?l=tr&platform=watch';
export const APP_ANDROID_URL = 'https://play.google.com/store/apps/details?id=tr.com.idefix.vendor&referrer=utm_source%3Dappbrain%26utm_medium%3Dappbrain_web%26utm_campaign%3Dappbrain_web';

// QR kodun ve yönlendirmenin kullanacağı uygulama içi yol.
export const APP_DOWNLOAD_PATH = '/app';

// QR kodun işaret edeceği tam (absolute) URL.
// QR harici bir cihazla okunacağı için origin (alan adı) şarttır.
export function getAppDownloadUrl(): string {
  if (typeof window === 'undefined') return APP_DOWNLOAD_PATH;
  return `${window.location.origin}${APP_DOWNLOAD_PATH}`;
}

export type MobilePlatform = 'ios' | 'android' | 'other';

export function detectMobilePlatform(userAgent?: string): MobilePlatform {
  if (typeof navigator === 'undefined' && !userAgent) return 'other';

  const ua = userAgent ?? navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/i.test(ua)) return 'ios';

  // iPadOS 13+: Safari masaüstü UA'sı (Macintosh) gönderir; touch ile ayırt edilir.
  if (
    typeof navigator !== 'undefined' &&
    navigator.maxTouchPoints > 1 &&
    (/MacIntel|Macintosh/i.test(navigator.platform || '') || /Macintosh|Mac OS X/i.test(ua))
  ) {
    return 'ios';
  }

  return 'other';
}

/** Telefon / tablet (mweb) — gerçek masaüstü değil. */
export function isMobileOrTabletDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

  if (detectMobilePlatform() !== 'other') return true;

  // Touch tablet/telefon: hover yok + coarse pointer
  if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return true;

  // iPadOS "Masaüstü Web Sitesi İste" fallback
  if (navigator.maxTouchPoints > 1 && /Macintosh|Mac OS X/i.test(navigator.userAgent)) return true;

  return false;
}

export function getStoreUrlForPlatform(platform: MobilePlatform): string | null {
  if (platform === 'ios') return APP_IOS_URL || null;
  if (platform === 'android') return APP_ANDROID_URL || null;
  return null;
}
